// externals
import type { Reducer } from 'redux';

// libraries
import type { TestDriveState } from '@makemydeal/dr-dash-types';
import { initActionTypes } from '@makemydeal/dr-shared-store';

// consts/enums
import { CLEAR_TEST_DRIVE } from '../actionTypes/testDriveActionTypes';

export type TestDriveTime = 'morning' | 'afternoon' | 'evening';

export const INITIAL_TEST_DRIVE_STATE: Partial<TestDriveState> = {};

export type TestDriveReducer = Reducer<TestDriveState | null>;

export const reducer: TestDriveReducer = (state: Partial<TestDriveState> | null = INITIAL_TEST_DRIVE_STATE, action: any) => {
    switch (action.type) {
        case initActionTypes.INIT_PENCIL_SUCCESS: {
            return {
                ...state,
                ...(action.payload.testDrive || {})
            };
        }
        case CLEAR_TEST_DRIVE: {
            return null;
        }
        default: {
            return state;
        }
    }
};
